/**
 * Number of meters in one nautical mile
 * @type {number}
 */
export const NAUTICAL_MILE_IN_METERS = 1852;

/**
 * @enum {string}
 */
export const LIGHT_CONDITION = {
  DAY: 'DAY',
  DUSK: 'DUSK',
  NIGHT: 'NIGHT',
};

/**
 * @enum {string}
 */
export const COORDINATE_FORMAT = {
  DEGREE_MINUTE_DECIMAL: 'DMD',
  DEGREE_MINUTE_SECOND: 'DMS',
  DEGREE_DECIMAL: 'DD',
};

export const ALLOW_HOVER_CSS_CLASS = 'can-hover';

export const ZOOMSLIDER_VISIBLE_CONTROL_LAYER_CSS_CLASS = 'ol-geomod-zoom-slider';
export const ZOOM_VISIBLE_CONTROL_LAYER_CSS_CLASS = 'ol-zoom-visible';
export const INFOBOARD_CONTROL_VISIBLE_CSS_CLASS = 'info-board-visible';

export const FONT_SIZE_PROFILES = {
  '--font-size': [1.2, 1.4, 1.6],
  '--medium-font-size': [1.6, 1.7, 1.8],
  '--title-font-size': [1.8, 1.9, 2],
  '--icon-size': [1.6, 1.8, 2],
};

export const PARTICULAR_FEATURE_TYPES = [
  'Vessel',
  'Information',
  'Photo',
  'Contact',
  'Warning',
  'Tirant d\'eau',
  'Harbours\' Note',
  'Quotation',
  'Harbor Obstruction',
  'Issue',
  'Wind',
  'Car',
  'Crane',
  'Anchor watch area',
  'ETA Point Of Boarding'
]